<div #bar class="impersonation-bar" role="status">
  <span><b>Signed in as:</b> {{ signedInAsEmail() }}</span>
  <span><b>Employee:</b> {{ impersonatorEmail() }}</span>
  <span class="time-left">{{ formatTimeLeft(timeLeft()) }} remaining</span>
  <button
    mat-stroked-button
    type="button"
    class="exit"
    aria-label="Exit impersonation"
    (click)="exit.emit()"
  >
    Exit
  </button>
</div>
